import { pitchUnitStyles } from "./PitchUnit.css";
import { PitchUnitProps } from "./types";

const PitchUnit = ({ children, pitchUnitRef }: PitchUnitProps) => (
  <div ref={pitchUnitRef} className={pitchUnitStyles}>
    {children}
  </div>
);

export default PitchUnit;
